var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpVideosIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.1661H13.5139M13.5 16.9995C14.7369 14.352 17.6667 14.5472 17.6667 11.4439C17.6667 9.36057 16.2778 7.27724 13.5 7.27724C11.3501 7.27724 10.0323 8.52507 9.54628 10.055M13.5 26.7217C20.4036 26.7217 26 21.1253 26 14.2217C26 7.31812 20.4036 1.72168 13.5 1.72168C6.59644 1.72168 1 7.31812 1 14.2217C1 21.1253 6.59644 26.7217 13.5 26.7217Z",
    stroke: "url(#paint0_linear_1_839)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_839",
    x1: 1,
    y1: 14.2217,
    x2: 26,
    y2: 14.2217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02AAB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CDAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpVideosIcon);
export default __webpack_public_path__ + "static/media/HelpVideosIcon.6ae9225ec5a8813ffcb711bebe40d22d.svg";
export { ForwardRef as ReactComponent };